export function isMainTenant() {
  const mainTenant = process.env.VUE_APP_MAIN_TENANT;

  if (!mainTenant) {
    console.warn('VUE_APP_MAIN_TENANT não definida');
    return false;
  }
  console.log( window.location.hostname, mainTenant);
  return window.location.hostname === mainTenant;
}
